var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCounter01 = function SvgIconCounter01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_counter-01_svg2__a",
    x1: -2.51,
    x2: 116,
    y1: 71,
    y2: 23.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_counter-01_svg2__a",
    id: "icon_counter-01_svg2__b",
    x1: -2.51,
    x2: 116,
    y1: 71,
    y2: 23.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_counter-01_svg2__a",
    id: "icon_counter-01_svg2__c",
    x1: -2.57,
    x2: 115.95,
    y1: 70.86,
    y2: 23.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_counter-01_svg2__a",
    id: "icon_counter-01_svg2__d",
    x1: -6.39,
    x2: 112.12,
    y1: 61.29,
    y2: 13.89
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M92.27 23.48H7.73C3.47 23.48 0 26.95 0 31.21v37.58c0 4.26 3.47 7.73 7.73 7.73h84.55c4.26 0 7.73-3.47 7.73-7.73V31.21c0-4.26-3.47-7.73-7.73-7.73Zm4.8 45.31c0 2.65-2.15 4.8-4.8 4.8H7.73c-2.65 0-4.8-2.15-4.8-4.8V31.21c0-2.65 2.15-4.8 4.8-4.8h84.55c2.65 0 4.8 2.15 4.8 4.8v37.58Z",
    style: {
      fill: "url(#icon_counter-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.27 29.75H75.05c-.81 0-1.46.66-1.46 1.46s.66 1.46 1.46 1.46h3.15c-2.19 3.06-3.61 4.92-4.44 6.01-1.28 1.68-1.63 2.13-1.36 3 .15.49.52.86 1.02 1.03.2.07.48.16 4.41.16 1.58 0 3.75-.02 6.74-.05a1.464 1.464 0 1 0-.03-2.93c-2.52.03-5.84.06-8.05.05 1.04-1.37 2.75-3.64 5.3-7.26h9.01v34.65h-5.53a6.92 6.92 0 0 0-2.53-4.14 6.9 6.9 0 0 0 2.65-5.43c0-3.8-3.09-6.9-6.9-6.9-3.29 0-6.13 2.34-6.77 5.56-.16.79.36 1.56 1.16 1.72.79.16 1.56-.36 1.72-1.16.36-1.85 2-3.2 3.89-3.2 2.19 0 3.97 1.78 3.97 3.97s-1.78 3.97-3.97 3.97c-.81 0-1.46.66-1.46 1.46s.66 1.46 1.46 1.46c1.74 0 3.21 1.12 3.75 2.68h-16.7V32.67h3.23c.81 0 1.46-.66 1.46-1.46s-.66-1.46-1.46-1.46H7.73c-.81 0-1.46.66-1.46 1.46v37.58c0 .81.66 1.46 1.46 1.46h4.7c.81 0 1.46-.66 1.46-1.46s-.66-1.46-1.46-1.46H9.2V32.68h25.25v34.65H18.69c-.81 0-1.46.66-1.46 1.46s.66 1.46 1.46 1.46h73.59c.81 0 1.46-.66 1.46-1.46V31.21c0-.81-.66-1.46-1.46-1.46Zm-54.9 2.93h25.25v34.65H37.37z",
    style: {
      fill: "url(#icon_counter-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.76 38.09h-4.48c-.81 0-1.46.66-1.46 1.46s.66 1.46 1.46 1.46h3.01v19.48c0 .81.66 1.46 1.46 1.46s1.46-.66 1.46-1.46V39.55c0-.81-.66-1.46-1.46-1.46Z",
    style: {
      fill: "url(#icon_counter-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.29 54.87v-9.69c0-4.15-3.37-7.52-7.52-7.52s-7.52 3.37-7.52 7.52v9.69c0 4.15 3.37 7.52 7.52 7.52s7.52-3.37 7.52-7.52m-12.11 0v-9.69c0-2.53 2.06-4.59 4.59-4.59s4.59 2.06 4.59 4.59v9.69c0 2.53-2.06 4.59-4.59 4.59s-4.59-2.06-4.59-4.59",
    style: {
      fill: "url(#icon_counter-01_svg2__d)"
    }
  }));
};
export default SvgIconCounter01;